import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ObservablesService } from 'src/app/services/observables/observables.service';

@Injectable({
  providedIn: 'root',
})
export class UbicacionesService {
  constructor(
    private http: HttpClient,
    public router: Router,
    private observables: ObservablesService
  ) {}

  getPaises(): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {};

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-paises',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error Paises: ', err);
            let msgError = 'Error Paises.';

            observer.error(msgError);
          }
        );
    });
  }

  getProvincias(pais: any): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        pais: pais
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-provincias',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error Provincias: ', err);
            let msgError = 'Error Provincias.';

            observer.error(msgError);
          }
        );
    });
  }

  getPoblaciones(provincia: any): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        provincia: provincia
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-poblaciones',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error Poblaciones: ', err);
            let msgError = 'Error Poblaciones.';

            observer.error(msgError);
          }
        );
    });
  }
}
